import { AppIcons } from './AppIcons'

export type Props = {
  icon: () => JSX.Element
}

export enum AppIconsNames {
  Default = 'default',
  FS = 'fs',
  RocketDesigner = 'rocket-designer',
  CMS = 'cms',
  Calendar = 'calendar',
  Chat = 'chat'
}

export const applicationTypes: {
  [key: string]: Props
} = {
  [AppIconsNames.Default]: {
    icon: AppIcons.Default
  },
  [AppIconsNames.FS]: {
    icon: AppIcons.FS
  },
  [AppIconsNames.RocketDesigner]: {
    icon: AppIcons.RocketDesigner
  },
  [AppIconsNames.CMS]: {
    icon: AppIcons.CMS
  },
  [AppIconsNames.Chat]: {
    icon: AppIcons.Chat
  },
  [AppIconsNames.Calendar]: {
    icon: AppIcons.Calendar
  }
}

export const colors = {
  fs: '#455aea',
  rocketDesigner: '#f44646',
  cms: '#00749c',
  chat: '#3dbaf1',
  calendar: '#27acc5'
}
